export default __webpack_public_path__ + "static/retail-software-testing-33665ba4d5af39a531433edb57a336be.jpg";